import { useNavigate } from "react-router-dom";
import errorImage from "../../assets/images/notfound.jpg";
import { Button } from "@InnoUI/";
import theme from "@theme/";
import SC from "./style";

const PageNotFound = (props) => {
  const {
    heading = "Oops! Page Not Found",
    message = "The page you are looking for doesn't exist or might have been moved.",
  } = props;
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate("/");
  };

  return (
    <SC.PageStyles>
      <SC.ImageStyles src={errorImage} />
      <SC.HeadingStyles>{heading}</SC.HeadingStyles>
      <SC.ParagraphStyles>{message}</SC.ParagraphStyles>
      <Button
        caption={"Go Back Home Page"}
        onClick={handleGoBack}
        color="white"
        fontSize="12px"
        style={{
          marginBottom: 8,
          background: theme.gradient.themeGradient,
          color: theme.colors.white,
          minWidth: "90px",
          height: "30px",
          borderRadius: "3px",
        }}
      />
    </SC.PageStyles>
  );
};

export default PageNotFound;
